if (!customElements.get('tagged-lookbook-slider')) {
  class TaggedLookbookSlider extends HTMLElement {
    connectedCallback() {
      if (this.swiper || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(this.querySelector('.tagged-lookbook__slider'), {
        slidesPerView: 1.18,
        spaceBetween: 16,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.tagged-lookbook__button--previous'),
          nextEl: this.querySelector('.tagged-lookbook__button--next')
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 26
          }
        }
      });
    }

    disconnectedCallback() {
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define('tagged-lookbook-slider', TaggedLookbookSlider);
}
